import { TeamTurns } from "./Game";
import { Difficulty } from "./Question";
import { SchoolType } from "./User";

export interface CategoryEntity {
  _id?: string;
  title?: string;
  imageUrl?: string;
  schoolTypes?: Array<SchoolType>;
}

export interface Category {
  id: string;
  title: string;
  imageUrl: string;
  isSelected: boolean;
  schoolTypes: Array<SchoolType>;
  pointsHashmap: Map<TeamTurns, Map<Difficulty, boolean>>;
}

export function convertPointsHashmapStringToMap(
  decodedJson: string,
): Map<TeamTurns, Map<Difficulty, boolean>> {
  const parsedObject = JSON.parse(decodedJson);

  // 2.  Rebuild the nested Maps with explicit casting
  const pointsHashmap = new Map<TeamTurns, Map<Difficulty, boolean>>(
    Object.entries(parsedObject).map(([teamKey, difficultiesObj]) => {
      // Cast the outer key to your TeamTurns enum
      const team = teamKey as TeamTurns;

      // Build the inner map by casting its keys explicitly
      const innerMap = new Map<Difficulty, boolean>(
        Object.entries(difficultiesObj as Record<string, boolean>).map(
          ([diffKey, isCompleted]) => [
            diffKey as Difficulty, // <--- This is the exact fix for your error
            isCompleted,
          ],
        ),
      );

      return [team, innerMap];
    }),
  );
  return pointsHashmap;
}

export function convertCategoryEntityToCategory(
  categoryEntity: CategoryEntity,
): Category {
  const pointsHashmap: Map<TeamTurns, Map<Difficulty, boolean>> = new Map([
    [
      TeamTurns.teamA,
      new Map([
        [Difficulty.EASY, false],
        [Difficulty.MEDIUM, false],
        [Difficulty.HARD, false],
      ]),
    ],
    [
      TeamTurns.teamB,
      new Map([
        [Difficulty.EASY, false],
        [Difficulty.MEDIUM, false],
        [Difficulty.HARD, false],
      ]),
    ],
  ]);
  return {
    id: categoryEntity._id!,
    title: categoryEntity.title!,
    imageUrl: categoryEntity.imageUrl!,
    schoolTypes: categoryEntity.schoolTypes!,
    isSelected: false,
    pointsHashmap: pointsHashmap,
  };
}

export function convertCategoryEntityListToCategoryList(
  categoryEntities: Array<CategoryEntity>,
): Array<Category> {
  const categories: Array<Category> = [];

  categoryEntities.map((categoryEntity, i) => {
    categories.push(convertCategoryEntityToCategory(categoryEntity));
  });
  return categories;
}
